<template>
  <div class="app-main-inner">
    <div style="width: fit-content">
      <div class="section">
        <el-form ref="basicForm" :inline="true" label-position="left">
          <div class="el-form-item-group">
            <el-form-item :label="$t('SeaExport.MasterBusinessNo')" lable-width="90px">
              <el-input v-model="job.jobNo" no="1" :disabled="true" class="jobNo-color" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.WarehouseNo')" lable-width="60px">
              <el-input v-model="job.warehouseNo" no="2" :disabled="true" />
            </el-form-item>
            <el-form-item label="MBL" lable-width="60px">
              <el-input v-model="job.mbl" no="3" :disabled="readonly||isCrossTenantSEToSI" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerReferenceNumber')" lable-width="90px">
              <cargo-input v-model="job.customerRefNo" no="4" :disabled="readonly" :trim="true" />
            </el-form-item>
            <el-form-item lable-width="0px">
              <el-checkbox v-model="job.usCustomsClearance" no="5" :disabled="readonly">{{ $t('queryJob.UsCustomsClearance') }}</el-checkbox>
            </el-form-item>
            <el-form-item lable-width="0px">
              <el-checkbox v-model="job.insure" :disabled="readonly">{{ $t('SeaExport.InsureInfo') }} </el-checkbox>
            </el-form-item>
            <el-checkbox v-if="showTrucking" v-model="job.landTransportation" no="6" :disabled="readonly">{{ $t('SeaExport.DeliveryToDoor') }}</el-checkbox>
            <el-checkbox v-model="job.importManifest" no="6.5" :disabled="readonly">{{ $t('SeaImport.ImportManifest') }}</el-checkbox>
          </div>
        </el-form>
      </div>
      <div style="display: flex">
        <el-form ref="basicForm" style="display: flex;" label-position="right" :label-width="isZh ? '135px' : '160px'">
          <div class="center-first section form-column" style="width: 349px">
            <template v-if="isZY">
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.AllowSaleProduct') }}</span>
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_AllowSaleProduct"
                  filterable
                  no="allowSaleProduct"
                  :disabled="readonly"
                  clearable
                  :data-filter-function="p => p.statusEnabled && p.seaImportEnabled"
                  :default-value="job.saleProductCode || ''"
                  @parentCallBack="p => {job.saleProductCode = p.value}"
                />
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.FullOrInside') }}</span>
                <cargo-advance-select
                  :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
                  no="fullOrInside"
                  :disabled="readonly"
                  clearable
                  :default-value="job.fullOrInside || ''"
                  @parentCallBack="p => {job.fullOrInside = p.value}"
                />
              </el-form-item>
            </template>
            <el-form-item :label="$t('SeaExport.SolicitationType')">
              <el-select
                v-model="job.cargoSource"
                no="7"
                :disabled="readonly"
                :placeholder="$t('SeaExport.PleaseSelect')"
                size="mini"
                @change="val=>{pm.cargoSourceChange(val)}"
              >
                <el-option
                  v-for="(item,index) in CARGO_SOURCES"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>&nbsp;
            </el-form-item> <el-form-item :label="$t('SeaExport.CustomJobType')">
              <cargo-advance-select
                no="8"
                filterable
                :clearable="true"
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                :static-options="customJobTypeList"
                :method-params="{type:job.lob}"
                :default-value="job.customJobType"
                @parentCallBack="p=>{job.customJobType=p.value;onCustomJobTypeChange(p)}"
              />
            </el-form-item>
            <el-form-item v-if="job.customJobType && secondaryCustomJobTypeList.length > 0" :label="$t('CargoMsg.Cargo_Grade')">
              <cargo-advance-select
                ref="secondaryCustomJobType"
                no="secondaryCustomJobType"
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                filterable
                :cache="false"
                :default-value="job.secondaryCustomJobType"
                :tag-name="isZh?'name':'englishName'"
                :static-options="secondaryCustomJobTypeList"
                @parentCallBack="p=>{job.secondaryCustomJobType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OrderChannels')">
              <el-input v-model="job.salesChannel" no="9" :disabled="true" />
            </el-form-item>
            <el-form-item v-if="isCrossTenantSEToSI" :label="$t('SeaExport.ConsignationRelationNumber')">
              <el-input no="10" :value="job.trustFromJob" :disabled="true" />
            </el-form-item>
            <el-form-item v-if="isCrossTenantSEToSI" :label="$t('SeaExport.BusinessCommissionedRelationNumber')">
              <el-input no="relatedJob" :value="job.relatedJob" :disabled="true" />
            </el-form-item>
            <!--CARGO-18489 新增“渠道单号”字段,显示渠道单号时隐藏委托关联号-->
            <el-form-item v-if="showChannelNo" :label="$t('SeaExport.ChannelNo')">
              <el-input no="11" :value="job.channelNo" :disabled="true" />
            </el-form-item>
            <el-form-item v-if="visibleDesignationAgent" :label="$t('SeaExport.NominatedAgent')">
              <cargo-company-select
                no="12"
                :disabled="!controllerEnable.txtDesignationAgent"
                :method-params="{designationAgent:true,active:true}"
                :default-value="job.designationAgent||''"
                tag-name="englishName"
                @change="p=>{pm.designationAgentChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfLoadingAgent')">
              <div style="display: flex;align-items: center">
                <el-tooltip
                  v-show="sopImageB"
                  no="13"
                  :content="$t('SeaExport.SOPReceiver')"
                  placement="right-end"
                >
                  <div>
                    <img
                      :src="sopPic"
                      width="18"
                      height="28"
                      style="padding: 5px 0;cursor: pointer"
                      @click="pm.sopChangeCustomerIdHandler()"
                    >
                  </div>
                </el-tooltip>
              </div>
              <cargo-company-select
                no="14"
                :disabled="readonly"
                :method-params="{overseaAgent:true,active:true}"
                :default-value="job.destinationAgent||''"
                tag-name="englishName"
                @change="p=>{pm.txtDestinationAgentChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ShippingCompany')">
              <cargo-company-select
                no="15"
                :disabled="!controllerEnable.txtCarrierId||isCrossTenantSEToSI"
                :method-params="{companyLob:'seaImport',seaCmp:true,active:true}"
                :default-value="job.carrierId||''"
                @change="p=>{job.carrierId=p.value;onCarrierIdChange()}"
              />
            </el-form-item>
            <el-form-item v-if="bookingAgentVisible" :label="$t('SeaExport.BookingAgent')">
              <cargo-company-select
                no="16"
                :disabled="!controllerEnable.txtBookingAgent||isCrossTenantSEToSI"
                :method-params="{bookingAgent:true,companyLob:'seaImport',active:true}"
                :default-value="job.bookingAgent||''"
                @change="p=>{job.bookingAgent=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BillExchangeAgent')">
              <cargo-company-select
                no="100"
                :disabled="readonly"
                :method-params="{bookingAgent:true,companyLob:'seaImport',active:true}"
                :default-value="job.exChangeAgent||''"
                @change="p=>{job.exChangeAgent=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsNo')">
              <el-input v-model="job.customsNo" no="17" :disabled="readonly" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SoNo')">
              <so-no-input v-model="job.jobSoNo" no="18" :disabled="readonly" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.VesselOfChineseName')">
              <cargo-input v-model="job.vesselChineseName" no="19" :disabled="readonly" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Vessel')">
              <cargo-input v-model="job.vessel" no="20" :disabled="readonly||isCrossTenantSEToSI" :auto-uppercase="isUppercase" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Voyage')">
              <div style="display: flex;justify-content: space-between">
                <el-input v-model="job.voyageFlight" no="21" :disabled="readonly||isCrossTenantSEToSI" style="flex: 1" :auto-uppercase="isUppercase" />
                <el-checkbox v-model="isTwoVessel" no="22" style="margin-left: 5px" :disabled="readonly">{{ $t('SeaExport.SecondCheck') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item v-if="isTwoVessel" :label="$t('SeaExport.SecondVessel')">
              <cargo-input v-model="job.secondVessel" no="23" :disabled="readonly" :auto-uppercase="isUppercase" />
            </el-form-item>
            <el-form-item v-if="isTwoVessel" :label="$t('SeaExport.SecondVoyage')">
              <cargo-input v-model="job.secondVoyage" no="24" :disabled="readonly" :auto-uppercase="isUppercase" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfReceipt')">
              <cargo-input v-model="job.dispatchingPlace" no="25" :disabled="readonly||isCrossTenantSEToSI" :auto-uppercase="isUppercase" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.PortOfLoading') }}</span>
              <cargo-advance-select
                ref="loadingPortCode"
                no="26"
                filterable
                :disabled="readonly||isCrossTenantSEToSI"
                :placeholder="$t('SeaExport.RequiredItem')"
                :select-type="selectTypeNames.basic_data_Seaport"
                :default-value="job.loadingPortCode"
                :method-params="{}"
                @parentCallBack="loadingPortCodeChange"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.PortOfDischarge') }}</span>
              <cargo-advance-select
                no="27"
                filterable
                :disabled="readonly||isCrossTenantSEToSI"
                :placeholder="$t('SeaExport.RequiredItem')"
                :callback-params="{key:'dischargingPortCode'}"
                :select-type="selectTypeNames.basic_data_Seaport"
                :default-value="job.dischargingPortCode"
                :method-params="{}"
                @parentCallBack="p=>{job.dischargingPortCode=p.value;pm.dischargingPortCode_Change(p.value)}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.PlaceOfDelivery') }}</span>
              <cargo-advance-select
                no="destinationPortCode"
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_Seaport"
                filterable
                :default-value="job.destinationPortCode"
                :placeholder="$t('SeaExport.RequiredItem')"
                @parentCallBack="p=>{job.destinationPortCode=p.value;pm.destinationPortCodeEasyChange(p)}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.FinalDestination') }}</span>
              <cargo-input v-model="job.destinationPlace" no="28" :disabled="readonly||isCrossTenantSEToSI" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationDate')">
              <el-date-picker
                v-model="job.customsDate"
                no="29"
                :disabled="readonly"
                clearable
                style="width:100%;"
                type="date"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BookingDate')">
              <el-date-picker
                v-model="job.bookingDate"
                no="30"
                :disabled="readonly"
                type="date"
                style="width:100%;"
                clearable
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.DateOfDeparture2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  v-model="job.etd"
                  no="31"
                  class="departure-date-picker"
                  :disabled="!controllerEnable.dfETD||isCrossTenantSEToSI"
                  :placeholder="$t('SeaExport.RequiredItem')"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="flex: 1;margin-right: 5px"
                  clearable
                  @input="etdChange"
                />
                <span>{{ job.sailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.DateOfArrival2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  v-model="job.eta"
                  no="32"
                  :disabled="readonly"
                  :placeholder="$t('SeaExport.RequiredItem')"
                  style="flex: 1;margin-right: 5px"
                  type="date"
                  clearable
                  value-format="yyyy-MM-dd"
                  @input="etaChange"
                />
                <span>{{ job.etaSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.ActualDateOfDeparture2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  v-model="job.atd"
                  no="33"
                  :disabled="readonly"
                  style="flex: 1;margin-right: 5px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  @input="atdChange"
                />
                <span>{{ job.atdSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.ActualDateOfArrival2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  v-model="job.ata"
                  no="34"
                  :disabled="readonly"
                  style="flex: 1;margin-right: 5px"
                  type="date"
                  clearable
                  value-format="yyyy-MM-dd"
                  @input="ataChange"
                />
                <span>{{ job.ataSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ArrivalTime2')">
              <el-date-picker
                v-model="job.arrivalTime"
                no="123"
                :disabled="readonly"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsBroker')">
              <cargo-advance-select
                no="35"
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_Company"
                :data-filter-function="customsBrokerFilter"
                filterable
                :default-value="job.customsBroker||''"
                :method-params="{customsBroker:true,companyLob:'seaImport',active:true}"
                @parentCallBack="p=>{pm.customsBrokerChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsDeclarationMethod')">
              <cargo-advance-select
                no="customsMethod"
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_CustomsMode"
                :method-params="{serviceType:2}"
                tag-value="serialNum"
                filterable
                :default-value="job.customClaim"
                @parentCallBack="p=>{job.customClaim=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsDeclarationType')">
              <cargo-advance-select
                no="customsDeclarationType"
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
                filterable
                :default-value="job.customsDeclarationType||''"
                :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
                @parentCallBack="p=>{job.customsDeclarationType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeMethod')">
              <cargo-advance-select
                no="36"
                filterable
                :disabled="readonly"
                :clearable="false"
                :select-type="selectTypeNames.basic_data_TradeTerm"
                :method-params="{}"
                callback-method-type="value"
                :default-value="job.tradeTerm+''"
                :callback-params="{key:'tradeTerm'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ContractRateProperty')">
              <el-select
                ref="bookingTerm"
                v-model="job.bookingTerm"
                no="37"
                :disabled="readonly||isCrossTenantSEToSI"
                :placeholder="readonly ? '' : $t('SeaExport.PleaseSelect')"
                :clearable="false"
                size="mini"
              >
                <el-option
                  v-for="(item,index) in bookingTerms"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ShippingCompanyContractNo')">
              <el-input v-model="job.scNo" no="38" :disabled="readonly" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FreeDemurrage')">
              <auto-number-input
                v-model="job.freeDemurrage"
                no="39"
                :precision="0"
                :min="0"
                :disabled="readonly"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FreeDetention')">
              <auto-number-input
                v-model="job.freeDetention"
                no="40"
                :precision="0"
                :min="0"
                :disabled="readonly"
              />
            </el-form-item>
            <el-form-item :label="$t('Message.TerminalLocation')">
              <cargo-company-select
                no="terminalCompany"
                :disabled="readonly"
                :method-params="{terminalCompany:true,companyLob:'seaImport',active:true}"
                :default-value="job.terminalCompany||''"
                style="width: 100%"
                @change="p=>{JobUtils.terminalCompanyChangeHandler(job, p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('Message.TerminalAddress')">
              <cargo-rich-textarea
                v-model="job.deliveryAddress"
                no="deliveryAddress"
                :disabled="readonly"
                style="height: 110px;"
                @dblclick.native="showAdvanceTextDialog($t('Message.TerminalAddress'),job.deliveryAddress,val=>{job.deliveryAddress=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_TransportSource')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_TransportSource"
                no="transportSource"
                :default-value="job.transportSource"
                :cache="false"
                :disabled="readonly"
                tag-value="code"
                placeholder=" "
                @parentCallBack="item=>job.transportSource=item.value"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ServiceStatisticalArea')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_StatisticArea"
                no="statisticArea"
                :default-value="job.statisticArea"
                :cache="false"
                :disabled="readonly"
                tag-value="code"
                placeholder=" "
                @parentCallBack="item=>job.statisticArea=item.value"
              />
            </el-form-item>
          </div>
          <div class="center-two section form-column">
            <el-form-item label="">
              <div style="display: flex;justify-content: flex-end">
                <el-button no="41" type="primary" :disabled="readonly" @click="pm.onExcerption()">{{ $t('SeaExport.CopyFromOtherBill') }}</el-button>
                <el-button no="42" type="primary" :disabled="readonly" @click="pm.onCodeSearch()">{{ $t('SeaExport.CodeSearching') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Shipper')">
              <div style="display: flex;justify-content: space-between">
                <cargo-input v-model="job.shipperCode" no="43" style="width:80px;margin-right: 5px" :disabled="readonly" :placeholder="readonly ? '' : $t('SeaExport.Code2')" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                <cargo-company-select
                  no="44"
                  :disabled="readonly"
                  :method-params="{shipper:true,active:true}"
                  :default-value="job.shipperId||''"
                  tag-name="englishName"
                  style="flex: 1;margin-bottom: 10px"
                  @change="data => {senderAndReceiverChange('shipper',data, 6, notUppercaseShipperConsigneNotify)}"
                />
              </div>
              <cargo-input
                v-model="job.shipperLine1"
                no="45"
                :disabled="readonly"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :use-read-only="true"
                :placeholder="readonly ? '' : $t('SeaExport.BillsOfLadingDoubleClickEject')"
                @dblclick.native="showSenderAndReceiverDialog('shipper',6, false, notUppercaseShipperConsigneNotify)"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Consignee')">
              <div style="display: flex;justify-content: space-between">
                <cargo-input
                  v-model="job.consigneeCode"
                  no="46"
                  style="width:80px;margin-right: 5px"
                  :disabled="readonly"
                  :placeholder="readonly ? '' : $t('SeaExport.Code2')"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  @change="pm.qConsigneeCode_focusOutHandler()"
                />
                <cargo-company-select
                  no="47"
                  :disabled="readonly"
                  :method-params="{consignee:true,active:true}"
                  :default-value="job.consigneeId||''"
                  tag-name="englishName"
                  style="flex: 1;margin-bottom: 10px"
                  @change="data => {senderAndReceiverChange('consignee',data, 6, true, notUppercaseShipperConsigneNotify)}"
                />
              </div>
              <cargo-input
                v-model="job.consigneeLine1"
                no="48"
                :disabled="readonly"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :use-read-only="true"
                :placeholder="readonly ? '' : $t('SeaExport.BillsOfLadingDoubleClickEject')"
                @dblclick.native="showSenderAndReceiverDialog('consignee',6, false, notUppercaseShipperConsigneNotify)"
                @blur="pm.qConsigneeAddr_focusOutHandler()"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.NotifyParty')">
              <div style="display: flex;justify-content: space-between">
                <cargo-input v-model="job.notifyCode" no="49" style="width:80px;margin-right: 5px" :disabled="readonly" :placeholder="readonly ? '' : $t('SeaExport.Code2')" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                <cargo-company-select
                  no="50"
                  :disabled="readonly"
                  :method-params="{notify:true,active:true}"
                  :default-value="job.notifyId||''"
                  tag-name="englishName"
                  style="flex: 1;margin-bottom: 10px"
                  @change="data => {senderAndReceiverChange('notify',data, 6, notUppercaseShipperConsigneNotify)}"
                />
              </div>
              <cargo-input
                v-model="job.notifyLine1"
                no="51"
                :disabled="readonly"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :placeholder="readonly ? '' : $t('SeaExport.BillsOfLadingDoubleClickEject')"
                :use-read-only="true"
                @dblclick.native="showSenderAndReceiverDialog('notify',6,false, notUppercaseShipperConsigneNotify)"
              />
            </el-form-item>

            <el-form-item
              label-width="0"
              class="auto-width"
            >
              <booking-sea-eq-data-grid
                :value="seaEqList"
                :container-load-type="job.containerLoadType"
                :is-edit="isEdit"
                :job="job"
                :hide-container-no="false"
                @eqQuantityChange="eqQuantityChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.EnglishDescriptionOfGoods')" style="margin-top: 10px">
              <cargo-rich-textarea
                v-model="job.cargoEnglishName"
                no="52"
                :disabled="readonly||isCrossTenantSEToSI"
                :text-chars="englishNameMaxChars"
                :warning-count="englishNameWarningCount"
                style="height: 110px;"
                :auto-uppercase="isUppercaseByConfig"
                @change="pm.txtCargoEnglishNameChangeHandler()"
                @dblclick.native="showAdvanceTextDialog($t('queryJob.englishDescriptionOfGoods'),job.cargoEnglishName,val=>{job.cargoEnglishName=val},false,null,isUppercaseByConfig , {
                  warningCount: englishNameWarningCount,
                  maxChar: englishNameMaxChars
                });focusAdvanceTextInput()"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ChineseDescriptionOfGoods')">
              <cargo-rich-textarea
                v-model="job.cargoChineseName"
                no="53"
                :disabled="readonly"
                :text-chars="maxChars"
                :warning-count="warningCount"
                :auto-half-word="false"
                style="height: 110px;"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),job.cargoChineseName,val=>{job.cargoChineseName=val});focusAdvanceTextInput()"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Marks')"> <cargo-rich-textarea
              v-model="job.mark"
              no="54"
              :disabled="readonly||isCrossTenantSEToSI"
              :text-chars="markMaxChars"
              :warning-count="markWarningCount"
              :auto-uppercase="isUppercaseByConfig"
              style="height: 110px;"
              @change="onMarkChange"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),job.mark,val=>{job.mark=val},false,null,isUppercaseByConfig , {
                warningCount: markWarningCount,
                maxChar: markMaxChars
              });focusAdvanceTextInput()"
            />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeTerms2')">
              <cargo-advance-select
                no="55"
                filterable
                :disabled="readonly||isCrossTenantSEToSI"
                :select-type="selectTypeNames.basic_data_IncoTerm"
                :method-params="{}"
                callback-method-type="value"
                :default-value="job.incoTerm+''"
                :callback-params="{key:'incoTerm'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PreCollection')">
              <div style="display: flex;justify-content: space-between">
                <el-input-number
                  no="56"
                  :value="job.depositReceived===0 ? undefined: job.depositReceived"
                  style="flex-grow: 1"
                  :disabled="readonly"
                  :controls="false"
                  :precision="3"
                  @input="val=>{job.depositReceived=val}"
                />
                <span>{{ localCurrency }}</span>
              </div>
            </el-form-item>
          </div>
          <div class="center-three section form-column">
            <el-form-item :label="$t('SeaExport.ActualQuantity')">
              <auto-number-input
                v-model="job.quantityActual"
                no="57"
                :precision="0"
                :min="0"
                :disabled="readonly||isCrossTenantSEToSI"
                @change="pm.quantityFocusInHandler()"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Package')">
              <cargo-packing-select
                no="58"
                :disabled="readonly||isCrossTenantSEToSI"
                :default-value="job.packing"
                @change="p=>{job.packing=p.value;pm.chargePacking()}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ActualWeight')">
              <div style="display: flex">
                <auto-number-input
                  v-model="job.weightActual"
                  no="59"
                  :precision="3"
                  :min="0"
                  :disabled="readonly||isCrossTenantSEToSI"
                  @change="weightContractChange"
                />
                <span>KGS</span>
              </div>
            </el-form-item>

            <el-form-item :label="$t('SeaExport.ActualVolume')">
              <div style="display: flex">
                <auto-number-input
                  v-model="job.cubageActual"
                  no="60"
                  :precision="3"
                  :min="0"
                  :disabled="readonly||isCrossTenantSEToSI"
                  @change="cubageContractChange"
                />
                <span>CBM</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ChargedWeightRT')">
              <div style="display: flex">
                <auto-number-input
                  v-model="job.chargeWeight"
                  no="61"
                  :precision="3"
                  :min="0"
                  :disabled="!controllerEnable.txtChargeWeight||isCrossTenantSEToSI"
                  @change="pm.chargeWeightChangeHandler()"
                />
                <span>M/T</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FLCLType')">
              <cargo-advance-select
                no="62"
                filterable
                :clearable="false"
                :disabled="readonly"
                :select-type="selectTypeNames.local_cache_ImportConstants$_cargoTypeInputList"
                callback-method-type="value"
                :default-value="job.containerLoadType"
                :tag-name="$store.getters.language==='zh'?'chineseName':'englishName'"
                tag-value="code"
                :callback-params="{key:'containerLoadType'}"
                @parentCallBack="obj=>pm.qCargoType_Change(obj)"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MBLTransportationClause')">
              <cargo-advance-select
                no="63"
                filterable
                :clearable="false"
                :disabled="readonly||isCrossTenantSEToSI"
                :select-type="selectTypeNames.basic_data_ShippingTerm"
                :method-params="{}"
                callback-method-type="value"
                :default-value="job.freightTermMBL+''"
                :callback-params="{key:'freightTermMBL'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MblCargoReleaseWay')">
              <cargo-advance-select
                no="64"
                :disabled="readonly"
                :clearable="false"
                :select-type="selectTypeNames.local_cache_ImportConstants$_importReleaseTypes"
                callback-method-type="value"
                :headers="[$t('Tool.Code')]"
                :fields="['code']"
                :default-value="job.releaseTypeMbl"
                :tag-name="$store.getters.language==='zh'?'chineseName':'englishName'"
                tag-value="code"
                :callback-params="{key:'releaseTypeMbl'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MasterBLFreightTerm')">
              <cargo-advance-select
                no="65"
                filterable
                :clearable="false"
                :disabled="readonly||isCrossTenantSEToSI"
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                :method-params="{}"
                callback-method-type="value"
                :default-value="job.paymentTermMBL+''"
                :callback-params="{key:'paymentTermMBL'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.HarborDistrict')">
              <cargo-input v-model="job.portDistrict" no="66" :disabled="readonly" :auto-uppercase="isUppercase" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BillExchangeDate')">
              <el-date-picker
                v-model="job.transDate"
                no="67"
                :disabled="readonly"
                type="date"
                clearable
                value-format="yyyy-MM-dd"
                style="width: 100%"
                @change="pm.dfCustDate_focusOutHandler()"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfDelivery')">
              <el-date-picker
                v-model="job.deliverDate"
                no="68"
                :disabled="readonly"
                type="date"
                clearable
                value-format="yyyy-MM-dd"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfArrivalTheWarehouse')">
              <el-date-picker
                v-model="job.arriveStorageDate"
                no="69"
                :disabled="readonly"
                type="date"
                clearable
                value-format="yyyy-MM-dd"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :label="openWarehouse ? $t('SeaExport.WarehouseSupplier') : $t('SeaExport.Warehouse')">
              <cargo-company-select
                ref="warehouse"
                no="70"
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{warehouse:true,active:true}"
                :default-value="job.warehouseCmp||''"
                :static-options="warehouseList"
                @change="p=>{pm.warehouseCmpChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item v-if="openWarehouse" :label="$t('SeaExport.WareHouseName')">
              <el-select
                v-model="job.warehouseName"
                no="warehouseName"
                :disabled="readonly || !job.warehouseCmp"
                :allow-create="true"
                filterable
                :clearable="true"
                @change="warehouseNameChangeHandler"
              >
                <el-option
                  v-for="(item,index) in warehouseNameList"
                  :key="index"
                  :label="item.warehouseName"
                  :value="item.warehouseName"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.SalesCompany') }}</span>
              <el-input v-model="txtSalesOffice" no="71" :disabled="true" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.Sales') }}</span>
              <cargo-user-select
                ref="sales"
                no="72"
                :disabled="!saleEnabled"
                :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
                :default-value="job.sales||''"
                :static-options="salesList"
                :placeholder="salesPrompt"
                @change="p=>{pm.salesChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesOfGoods')">
              <cargo-user-select
                no="73"
                :disabled="readonly"
                :method-params="{category:'role',shape:'salesOfGoods'}"
                :default-value="job.cargoSalesId||''"
                @change="p=>{job.cargoSalesId=p.value;pm.cargoSalesChargeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesDepartment')">
              <cargo-department-new-select
                no="74"
                :disabled="readonly || (isEdit && (job.sales=== 0 || !job.sales))"
                :sales-id="Number(job.sales)"
                :enables="true"
                :office-id="job.salesOffice"
                :department-id="Number(job.salesDepartment)"
                @change="p=>{job.salesDepartment=p.value;pm.departmentChargeHandler()}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationCompany')">
              <cargo-advance-select
                no="75"
                filterable
                :disabled="readonly || opOfficeDisabled"
                :select-type="selectTypeNames.basic_data_Office"
                :default-value="job.opOffice"
                :static-options="cacheOffices"
                placeholder=""
                @parentCallBack="p=>{job.opOffice=p.value;job.opDepartment=0;pm.opOfficeChangeHandler()}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.OperationDepartment') }}</span>
              <cargo-department-select
                ref="department"
                no="76"
                :disabled="!saleEnabled"
                :enables="true"
                :office-id="Number(job.opOffice)"
                :department-id="Number(job.opDepartment)"
                @change="p=>{job.opDepartment=p.value}"
              />
            </el-form-item><el-form-item :label="$t('SeaExport.Operation')">
              <cargo-user-select
                no="77"
                :disabled="readonly"
                :method-params="{officeId:job.opOffice,category:'role',shape:'siop'}"
                :default-value="job.op||''"
                :static-options="userPortRoleData.op"
                @change="p=>{job.op=p.value;pm.opChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerOffice')">
              <cargo-office-select
                no="csrOffice"
                :disabled="true"
                :office-id="Number(job.csrOffice)"
                @change="p=>{job.csrOffice=p.value;job.csrDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Customer_Service') }}</span>
              <cargo-department-select
                no="csrDepartment"
                :office-id="Number(job.csrOffice)"
                :enables="true"
                :disabled="readonly"
                :department-id="Number(job.csrDepartment)"
                @change="p=>{job.csrDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerService')">
              <cargo-user-select
                ref="csr"
                no="78"
                :disabled="readonly"
                :method-params="{officeId:pm.isEntrustOrder||job.salesOffice===1?job.opOffice:job.salesOffice,category:'role',shape:'csr'}"
                :default-value="job.csr||''"
                :static-options="userPortRoleData.csr"
                @change="p=>{pm.csrChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FieldOperation')">
              <cargo-user-select
                :disabled="readonly"
                :method-params="{officeId:job.opOffice,category:'role',shape:'siteOp'}"
                :default-value="job.siteOP||''"
                :static-options="userPortRoleData.siteOp"
                @change="p=>{JobUtils.siteOpChangeHandler(job, p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OverseaCustomerService')">
              <cargo-user-select
                ref="overseaOp"
                no="overseaOp"
                :disabled="readonly"
                class="input2"
                :default-value="job.overseaOp||''"
                :method-params="{category:'role',shape:'overseaOp'}"
                :static-options="isHC ? null : (userPortRoleData.overseaOp || overseaAgentUsersList)"
                :merge-load="true"
                @change="p=>{
                  job.overseaOp = p.value
                  OverseaCustomerUtils.overseaOpChangeHandler(view, p)
                }"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DocumentOffice')">
              <cargo-office-select
                no="dcOffice"
                :disabled="true"
                :office-id="Number(job.dcOffice)"
                @change="p=>{job.dcOffice=p.value;job.dcDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Documentation_Department') }}</span>
              <cargo-department-select
                no="dcDepartment"
                :office-id="Number(job.dcOffice)"
                :enables="true"
                :disabled="readonly"
                :department-id="Number(job.dcDepartment)"
                @change="p=>{job.dcDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Documents')">
              <cargo-user-select
                ref="dc"
                no="79"
                :disabled="readonly"
                :method-params="{officeId:job.opOffice,category:'role',shape:'doc'}"
                :default-value="job.dc||''"
                :static-options="userPortRoleData.doc"
                @change="p=>{pm.dcChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole1')">
              <cargo-user-select
                ref="userDefinedRoleId1"
                no="userDefinedRoleId1"
                :disabled="readonly"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
                :default-value="job.userDefinedRoleId1||''"
                :merge-load="true"
                :static-options="userPortRoleData.userDefinedRole1"
                @change="p=>{userDefinedRoleId1Handler(p)}"
              />
            </el-form-item>
            <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole2')">
              <cargo-user-select
                ref="userDefinedRoleId2"
                no="userDefinedRoleId2"
                :disabled="readonly"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
                :default-value="job.userDefinedRoleId2||''"
                :merge-load="true"
                :static-options="userPortRoleData.userDefinedRole2"
                @change="p=>{userDefinedRoleId2Handler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Remarks')">
              <cargo-rich-textarea
                v-model="job.remarks"
                no="80"
                :disabled="readonly||isCrossTenantSEToSI"
                :text-chars="maxChars"
                :warning-count="warningCount"
                :is-trim="true"
                style="height: 110px;"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),job.remarks,val=>{job.remarks=val});focusAdvanceTextInput()"
              />
            </el-form-item>
          </div>
          <div class="center-four section form-column">
            <el-form-item :label="$t('SeaExport.UserDefinedField1')">
              <el-input
                v-model="job.userDefinedField1"
                no="81"
                :disabled="readonly"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField1'),job.userDefinedField1,val=>{job.userDefinedField1=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField2')">
              <el-input
                v-model="job.userDefinedField2"
                no="82"
                type="textarea"
                :rows="5"
                :disabled="readonly"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField2'),job.userDefinedField2,val=>{job.userDefinedField2=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField3')">
              <el-input
                v-model="job.userDefinedField3"
                no="83"
                type="textarea"
                :rows="5"
                :disabled="readonly"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField3'),job.userDefinedField3,val=>{job.userDefinedField3=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField4')">
              <el-input
                v-model="job.userDefinedField4"
                no="84"
                type="textarea"
                :rows="5"
                :disabled="readonly"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField4'),job.userDefinedField4,val=>{job.userDefinedField4=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TaxNature')">
              <el-select
                v-model="job.taxNature"
                :disabled="readonly"
                no="taxNature"
                :placeholder="$t('SeaExport.PleaseSelect')"
                size="mini"
              >
                <el-option
                  v-for="(item,index) in TAX_NATURES"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>&nbsp;
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="section">
        <div class="form-row">
          <div class="title" style="width: 100%">
            {{ $t('SeaExport.TicketsInfo') }}
            <div ref="division" class="division" :style="{height:divisionHeight+'px'}" @mousedown="divisionEnabled=true">
              <div class="line" style="margin-top:2px" />
              <div class="line" />
            </div>
          </div>
          <div v-show="readonly" style="display:flex;justify-content: flex-start;margin-bottom: 5px;line-height: 28px;">
            <span style="margin-right: 5px;">{{ $t('SeaExport.TotalTickets') }}:</span><span style="margin-right: 5px;">{{ job.lclSlaves.length }}</span>
            <div v-show="viewSource === 'bookingWorkspace'" class="triggers">
              <el-button type="primary" no="85" :disabled="isEdit||viewSource === 'financeDetail' || viewSource === 'salesDetail'" @click="pm.btnCreate_clickHandler()">{{ $t('SeaExport.NewTickets') }}</el-button>
              <el-button type="primary" no="86" :disabled="!selectedRow ||viewSource === 'financeDetail' || viewSource === 'salesDetail'" @click="btnLcLEditClickHandler()">{{ $t('SeaExport.EditTickets') }}</el-button>
              <el-button type="primary" no="87" :disabled="isEdit||viewSource === 'financeDetail' || viewSource === 'salesDetail'" @click="pm.btnAdd_clickHandler()">{{ $t('SeaExport.AddTickets') }}</el-button>
              <el-button type="danger" no="88" :disabled="!selectedRow||viewSource === 'financeDetail' || viewSource === 'salesDetail'" @click="pm.btnRemove_clickHandler()">{{ $t('SeaExport.RemoveTickets') }}</el-button>
              <el-button type="primary" no="89" :disabled="isEdit||viewSource === 'financeDetail' || viewSource === 'salesDetail'" @click="pm.onBatchPrint()">{{ $t('SeaExport.BatchPrint') }}</el-button>
            </div>
          </div>
          <div style="min-height: 200px;flex-direction: column">
            <div ref="slaveDiv" style="display: flex;height:300px;">
              <cargo-ag-grid
                :grid-options="gridOptions"
                :column-defs="columnDefs"
                :row-data="job.lclSlaves||[]"
                @gridReady="params=>{gridApi=params.api}"
              />
            </div>
            <div style="display: flex;justify-content: flex-end">
              <div>{{ $t('SeaExport.TotalNumberOfPackages') }}：{{ lbTotal.lblTotalQuantity }} </div>
              <div>{{ $t('SeaExport.TotalWeight2') }}：{{ lbTotal.lblTotalWeight }} </div>
              <div>{{ $t('SeaExport.TotalCubage') }}：{{ lbTotal.lblTotalCubage }} </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <cargo-contacts-info-dialog
      v-if="showContactsInfoDialog"
      :visible.sync="showContactsInfoDialog"
      :customer-id="job.customerId"
      :customer-contact="job.customerContact"
    />
    <sop-dialog
      :visible.sync="showSopDialog"
      :cmp-idx="sopDialog.cmpIdx"
      :job="job"
      :agent="sopDialog.agent"
      lob="SI"
      :contact-list="sopDialog.contactList"
      @updateJob="$emit('updateJob')"
    />

    <!-- 高级文本弹框 -->
    <el-dialog
      ref="advanceTextDialog"
      v-el-drag-dialog
      no="90"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :disabled="readonly"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="!readonly" no="xxx" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="91"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>

    <!--  单号抄录-->
    <import-prompt-title-dialog
      :visible.sync="importPromptTitleDialog.visible"
      :lob="job.lob"
      @selected="p=>{pm.onExcerptionChangeFunc(p)}"
    />

    <!--  代码检索-->
    <import-bill-address-title-dialog :visible.sync="billAddressDialog.visible" :job="job" @callback="p=>{pm.codeSearchCallback(p)}" />

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      v-if="templateSelectorDialog.visible"
      ref="templateSelectorDialog"
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
    />

    <!-- 加入拼箱工作单查询弹窗 -->
    <query-lcl-dialog
      :visible.sync="queryLclDialog.visible"
      :job="job"
      @callback="rows=>{pm.queryLclWindowReturnHandler(rows)}"
    />
    <!-- 票数填写弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="92"
      :visible.sync="ticketDialog.visible"
      :title="$t('SeaExport.FillInQuantityOfVotes')"
      width="270px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form label-width="50px" label-position="right">
        <el-form-item :label="$t('SeaExport.Number')+'：'">
          <el-input-number v-model="ticketDialog.value" :precision="0" :min="1" :max="50" :controls="false" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button no="93" type="primary" @click="pm.toAddTicket()">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="94" type="primary" @click="ticketDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import sopPic from '@/assets/sop.png'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoContactsInfoDialog from '@/components/Cargo/Job/cargoContactsInfoDialog'
import cargoDepartmentNewSelect from '@/components/Cargo/Common/cargoDepartmentNewSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import cargoProjectSelect from '@/components/Cargo/Common/cargoProjectSelect'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import sopDialog from '@/components/Cargo/Job/sopDialog'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import selectData from '@/utils/selectData'
import SpecialRequestsGrid from '@/components/Cargo/Job/specialRequestsGrid'
import BookingSeaEqDataGrid from '@/components/Cargo/Job/bookingSeaEqDataGrid'
import soNoInput from '@/components/Cargo/Job/soNoInput'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { CARGO_SOURCES, LOG_SI_SEA_BOOKING, RATE_TYPE, TAX_NATURES } from '@/class/cargo/model/parameters/SystemConstants'
import ImportPromptTitleDialog from '@/components/Cargo/Job/importPromptTitleDialog'
import ImportBillAddressTitleDialog from '@/components/Cargo/Job/importBillAddressTitleDialog'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import CargoInput from '@/components/Cargo/Common/cargoInput'
import { BOOKING_TERMS_SEA } from '@/class/cargo/model/parameters/BookingTerm'
import { MasterBasicTabHP } from './masterBasicTabAction'
import ColumnUtils from '@/utils/ColumnUtils'
import { ErrorTip } from '@/utils/class/ErrorTip'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import QueryLclDialog from '@/components/Cargo/Job/queryLclDialog'
import SenderAndReceiver from '@/mixin/SenderAndReceiver'
import { getLoading } from '@/utils/utilBaseElement'
import { multiply, mergeArray } from '@/utils/commonUtil'
import lang from '@/lang'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { OverseaCustomerUtils } from '@/class/cargo/model/utils/OverseaCustomerUtils'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { SeaImCargoDoc } from '@/class/model/booking/SeaImCargoDoc'
import { DocumentManage } from '@/utils/commonUtil'
import { getBranchByLevel } from '@/utils/basicDataCache'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect.vue'
import BasicTabMixin from '@/mixin/BasicTabMixin'
import $store from '@/store'
import { Company } from '@/class/model/mdm/Company'

export default {
  name: 'MasterBasicTab',
  filters: {
    filterWeek(val) {
      switch (val) {
        case 'TUE': return lang.t('SeaExport.TUE')
        case 'WED': return lang.t('SeaExport.WED')
        case 'THU': return lang.t('SeaExport.THU')
        case 'FRI': return lang.t('SeaExport.FRI')
        case 'SAT': return lang.t('SeaExport.SAT')
        case 'SUN': return lang.t('Pricing.Sun')
        case 'MON':
        default: return lang.t('SeaExport.MON')
      }
    }
  },
  components: {
    cargoOfficeSelect,
    QueryLclDialog,
    CargoInput,
    AutoNumberInput,
    ImportBillAddressTitleDialog,
    ImportPromptTitleDialog, BookingSeaEqDataGrid, SpecialRequestsGrid, cargoAdvanceSelect, cargoContactsInfoDialog, sopDialog,
    cargoDepartmentNewSelect, cargoDepartmentSelect, cargoCompanySelect, soNoInput,
    cargoUserSelect, cargoProjectSelect, cargoPackingSelect, cargoRichTextarea, cargoTemplateSelectorDialog },
  mixins: [SenderAndReceiver, BasicTabMixin],
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    viewSource: {
      type: String,
      required: false
    },
    isCrossTenantSEToSI: { // 是否跨租户出口转进口
      type: Boolean,
      required: false
    },
    showTrucking: { type: Boolean, required: false },
    cooperateEdit: { type: Boolean, default: true }, // 能否修改
    bookingAgentVisible: { type: Boolean, default: true }
  },
  data() {
    return {
      isZh: this.$store.getters.language === 'zh',
      maxChars: 0,
      warningCount: -1,
      englishNameMaxChars: 0,
      markMaxChars: 0,
      englishNameWarningCount: -1,
      markWarningCount: -1,
      sopPic,
      CARGO_SOURCES,
      TAX_NATURES,
      rateType: RATE_TYPE,
      loading: false,
      pm: new MasterBasicTabHP(this),
      selectTypeNames: TYPE_NAMES,
      bookingTerms: BOOKING_TERMS_SEA,
      showContactsInfoDialog: false,
      optStatusDefs: {
        edit: 'edit', // edit
        view: 'view' // 查看
      },
      currentOptStatus: 'view',
      showSopDialog: false,
      sopDialog: {
        visible: false,
        cmpIdx: 0,
        agent: '',
        contactList: []
      },
      billAddressDialog: {
        visible: false
      },
      importPromptTitleDialog: {
        visible: false,
        params: {}
      },
      job: new SeaImportJob().fillDefaultValue().getData(),
      jobClass: new SeaImportJob(),
      txtSalesOffice: '', // 销售所在分公司
      contractStatuses: selectData.contractStatuses,
      contractStatusLabel: '',
      customerTip: '',
      customerLevel: {
        level: '',
        customerName: ''
      },
      seaEqList: [],
      isTwoVessel: false, // 是否显示二程航名船次
      isHC: false,
      partnerManagementMode: 0,
      visibleDesignationAgent: true, // 根据揽货类型，显示不同下拉组件
      configValue: {
        creditOpen: false // 是否开启信控
      },
      sopConfigOpen: false,
      sopImageA: false,
      sopImageB: false,
      sopImageC: false,
      salesList: null,
      salesPrompt: '',
      contactList: [],
      controllerEnable: {
        qCargoType: false,
        dfETD: false,
        txtCustomerId: false,
        txtDesignationAgent: false,
        txtBookingAgent: false,
        txtCarrierId: false,
        txtChargeWeight: false
      },
      customerRemarks: [], // 实际通知人下拉框数据源
      branchOfficeCheck: false,
      salesOfficeCheck: false, // 是否按照分公司控制 (1:开启分公司过滤 0:关闭分公司过滤)
      isShowAcPaymentPlaceBL: false, // 是否显示主单付款地点
      isUppercase: true,
      lbTotal: {
        lblTotalWeight: 0,
        lblTotalCubage: 0,
        lblTotalQuantity: 0
      },
      selectedRowIndex: -1,
      selectedRows: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onRowDataChanged: event => {
          this.onRowDataChanged(event)
        },
        onCellFocused: event => {
          this.selectedRowIndex = event.rowIndex
        },
        onSelectionChanged: event => {
          // 触发多选
          this.onMultipleSelected(event)
        },
        onCellDoubleClicked: event => {
          this.btnLcLEditClickHandler(event)
        },
        context: {
          componentParent: this
        }
      },
      gridParams: {},
      gridApi: {},
      columnDefs: null,
      templateSelectorDialog: {
        visible: false,
        ctx: new SeaImportJob(),
        category: '',
        data: {}
      },
      queryLclDialog: {
        visible: false
      },
      ticketDialog: {
        visible: false,
        value: 0
      },
      warehouseList: [],
      isAddUserDefinedRoles: false, // 是否显示自定义岗
      openWarehouse: false,
      warehouseNameList: [],
      JobUtils,
      overseaAgentUsersList: [], // 海外客服用户列表
      OverseaCustomerUtils,
      view: this,
      divisionEnabled: false,
      divisionHeight: 10,
      doc: new DocumentManage(),
      location: LOG_SI_SEA_BOOKING.code,
      userPortRoleData: {
        userDefinedRole1: null,
        userDefinedRole2: null,
        userDefinedRole3: null,
        userDefinedRole4: null,
        overseaOp: null,
        siteOp: null,
        doc: null,
        csr: null,
        op: null,
        seaLine: null,
        airline: null,
        railwayLine: null
      },
      secondaryCustomJobTypeList: [],
      customJobTypeList: [],
      isZY: false,
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    customerEnabled() {
      return this.isEdit && SecurityUtil.checkOffsetAutoCompleteEnabled(this.job, 'customerId')
    },
    saleEnabled() {
      return this.isEdit && !this.pm.isWithinCloseAccountDate
    },
    selectedRow() {
      return this.job.lclSlaves[this.selectedRowIndex]
    },
    officeList() {
      return this.context.officeList
    },
    config() {
      return this.context.config
    },
    showChannelNo() {
      return ['B2B', this.$t('Menu.WallTechFamily')].includes(this.job.salesChannel)
    },
    localCurrency() {
      return RateUtil.localCurrencyByOffice()
    },
    divisionHalfHeight() {
      return this.divisionHeight / 2
    },
    cacheOffices() {
      if (this.isRegionalCommission) {
        return getBranchByLevel(this.job.opOffice)
      } else {
        return null
      }
    },
    // 销售分公司
    salesOffice() {
      return this.job.salesOffice
    }
  },
  watch: {
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: '', checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      },
      {
        headerName: this.$t('SeaExport.BusinessNo'),
        field: 'jobNo',
        width: 120
      },
      {
        headerName: this.$t('SeaExport.Hbl'),
        field: 'hbl',
        width: 120
      },
      {
        headerName: this.$t('SeaExport.Shipper'),
        field: 'shipperCode',
        width: 120
      },
      {
        headerName: this.$t('SeaExport.Consignee'),
        field: 'consigneeCode',
        width: 120
      },
      {
        headerName: this.$t('SeaExport.PortOfDischarge'),
        field: 'dischargingPortCode',
        width: 150
      },
      {
        headerName: this.$t('SeaExport.PlaceOfDelivery'),
        field: 'destinationPortCode',
        width: 150
      },
      {
        headerName: this.$t('SeaExport.Quantity'),
        field: 'quantityContract',
        width: 120
      },
      {
        headerName: this.$t('SeaExport.GrossWeight'),
        field: 'weightContract',
        width: 120,
        cellRenderer: params => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 3)
        }
      },
      {
        headerName: this.$t('SeaExport.Cubage'),
        field: 'cubageContract',
        width: 120,
        cellRenderer: params => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 3)
        }
      },
      {
        headerName: this.$t('SeaExport.ChargedWeight'),
        field: 'chargeWeight',
        width: 200,
        cellRenderer: params => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 3)
        }
      }
    ]
  },
  mounted() {
    this.doc.set('dragging', e => {
      if (!this.divisionEnabled) {
        return
      }
      this.dragging(e)
    })
    this.doc.set('endDrag', () => {
      document.getElementById('app').classList.remove('disabled-select')
      this.divisionEnabled = false
    })
    document.addEventListener('mousemove', this.doc.get('dragging'), false)
    document.addEventListener('mouseup', this.doc.get('endDrag'), false)
    document.addEventListener('mouseleave', this.doc.get('endDrag'), false)
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.doc.get('dragging'), false)
    document.removeEventListener('mouseup', this.doc.get('endDrag'), false)
    document.removeEventListener('mouseleave', this.doc.get('endDrag'), false)
    this.doc.destory()
  },
  async created() {
    this.context.loading = true
    const loading = getLoading()
    await this.context.prepareData()
    this.isHC = String(this.config.get('ToExoSystem')) === 'HC'
    this.configValue.creditOpen = Number(this.config.get('creditOpen')) === 1
    this.partnerManagementMode = Number(this.config.get('PartnerManagementMode')) // 是否启用合作伙伴管理模式
    this.salesOfficeCheck = Number(this.config.get('SalesOfficeCheck')) === 1
    this.isAddUserDefinedRoles = Number(this.config.get('IsAddUserDefinedRoles')) === 1
    this.isZY = String(this.config.get('ToExoSystem')) === 'zy' // 显示中邮选项
    this.notUppercaseShipperConsigneNotify = Number(this.config.get('NotUppercaseShipperConsigneNotify')) !== 1
    this.isUppercaseByConfig = Number(this.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    this.pm.init()
    this.context.loading = false
    loading.close()
  },
  methods: {
    setJobSelectValue(obj) {
      this.job[obj.key] = obj.value
    },
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      this.openWarehouse = Number(this.config.get('isOpenWarehouse')) > 0
      for (const key in this.userPortRoleData) {
        this.userPortRoleData[key] = null
      }

      // 刷新 客户需求表格
      if (this.$refs['selectedSpecialRequest']) {
        this.$refs['selectedSpecialRequest'].toQuery()
      }

      const job = new SeaImportJob(row)
      this.job = row

      // 新建job
      if (!row.uuid) {
        this.seaEqList = job.seaEQ = job.seaEQ || []
        if (this.action === 'copy' && job.seaEQ && job.seaEQ.length > 0 && (!job.containers || job.containers.length === 0)) {
          for (const item of this.seaEqList) {
            item.joinContainerId = 0
          }
          ContainerUtil.autoJustContainerUsages(this.job)
        }
      } else {
        this.seaEqList = job.seaEQ
      }
      this.pm.updateView()
      JobUtils.setSailingDay(this.job)
      OverseaCustomerUtils.loadOverseaAgentChanged(this)
      JobUtils.getReceiptCharges(this.job)
      this.setSecondaryCustomJobTypeFunc()
      this.setCustomJobTypeFunc()
      if (this.$store.getters.enableFrontEndPlugin) {
        this.setUserDefinedRoleDataUI()
      }
    },
    async getSubmitData() {
      await this.validateForm()

      await this.pm.updateModel()

      const job = { ...this.job }

      // 避免循环引用
      if (Object.prototype.hasOwnProperty.call(job, 'containerUsages')) {
        for (const usage of job.containerUsages) {
          delete usage.container
        }
      }

      if (job.opDepartment === 0) {
        job.opDepartment = this.$store.getters.currentDeptId
      }
      if (job.masterFlag) { // 主票的时候，没有分单，所以不应该存在分单运费方式以及分单运输条款
        // 分单运费方式
        job.paymentTermHBL = ''
        // 分单运输条款
        job.freightTermHBL = ''
      }
      return {
        job,
        seaCargoDoc: this.job.seaCargoDoc,
        seaEQ: this.seaEqList,
        delseaEQUuids: this.job.delseaEQUuids,
        containers: (this.job.containers && this.job.containers.length > 0) ? this.job.containers.filter(p => p.isDirty === true) : [],
        delContainerUuids: this.job.delContainerUuids, // 删除的箱子uuid
        delContainerUsageUuids: this.job.delContainerUsageUuids // 删除的装箱uuid
      }
    },
    async validateForm() {
      await this.pm.checkModel()
    },
    loadingPortCodeChange(data) {
      this.job.loadingPortCode = data.value
      if (this.job.loadingPortCode) {
        const modifiedData = this.context.modifiedData
        modifiedData.lclSlaves = modifiedData.lclSlaves || []
        for (const slave of this.job.lclSlaves) {
          slave.loadingPortCode = this.job.loadingPortCode
          if (!modifiedData.lclSlaves.includes(slave)) {
            modifiedData.lclSlaves.push(slave)
          }
        }
      }
      JobUtils.matchUserPortConfig(this, this.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.job, warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }))
    },
    async etdChange(value) {
      this.job.etd = value
      this.job.sailingDay = JobUtils.dateChange(this.job.etd)
    },
    async etaChange(value) {
      this.job.eta = value
      this.job.etaSailingDay = JobUtils.dateChange(this.job.eta)
      await ChargeUtils.updateETDFee(this.job, this.job.eta, this.context, true)
    },
    async atdChange(value) {
      this.job.atd = value
      this.job.atdSailingDay = JobUtils.dateChange(this.job.atd)
    },
    async ataChange(value) {
      this.job.ata = value
      this.job.ataSailingDay = JobUtils.dateChange(this.job.ata)
    },
    async weightContractChange() {
      this.job.weightContract = this.job.weightActual
      await this.refreshWeightCharge(this.job, this.job.weightContract)
      this.pm.weightFocusInHandler()
    },
    async refreshWeightCharge(job, weight) {
      const charges = ChargeUtils.weightChargesCanUpdate(job)
      if (charges.length > 0) {
        await this.$confirm(this.$t('Message.WeightChangeToRefreshCostBasedOnWeightPrice'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          for (const charge of charges) {
            charge.quantity = weight
            if (charge.unitPriceIncludeTax) {
              ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            } else {
              ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            }
          }
          this.context.modifiedData.charges = this.context.modifiedData.charges || []
          mergeArray(this.context.modifiedData.charges, charges)
          this.context.reloadCharge = true
        }).catch(() => {})
      }
      ChargeUtils.wgttWeightChargesCanUpdate(job, weight, this.context)
    },
    async cubageContractChange() {
      this.job.cubageContract = this.job.cubageActual
      await this.refreshCubageCharge(this.job, this.job.cubageContract)
      this.pm.cubageFocusInHandler(true)
    },
    async refreshCubageCharge(job, cubage) {
      const charges = await ChargeUtils.cubageChargesCanUpdate(job)
      if (charges.length > 0) {
        await this.$confirm(this.$t('Message.CubageChangeToRefreshCostBasedOnCubagePrice'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          for (const charge of charges) {
            charge.quantity = cubage
            if (charge.unitPriceIncludeTax) {
              ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            } else {
              ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            }
          }
          this.context.modifiedData.charges = this.context.modifiedData.charges || []
          mergeArray(this.context.modifiedData.charges, charges)
          this.context.reloadCharge = true
        }).catch(() => {})
      }
    },
    customsBrokerFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customsBroker && item.seaImport && item.active
    },
    onRowDataChanged(event) {
      // 重置（多选）选中行
      this.selectedRows = []
    },
    // grid多选
    onMultipleSelected(event) {
      this.selectedRows = this.gridApi.getSelectedRows()
    },
    focusAdvanceTextInput() {
      setTimeout(() => {
        const qlEditor = this.$refs.advanceTextDialog.$el.getElementsByClassName('ql-editor')[0]
        qlEditor.focus()
      }, 100)
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      params.category = 'SIJOBNO'
      params.ctx = new SeaImportJob(this.job)
      params.JOB_UUID = this.job.uuid
      params.jobuuid = this.job.uuid
      this.$logger.log('params', params)
      return params
      // TemplateSelectorWin.getInstance().showThisWin(_job, "SIJOBNO", params, this);
    },
    /**
     * 编辑选择的拼箱分票
     */
    btnLcLEditClickHandler() {
      if (this.selectedRow) {
        this.$emit('selectJob', this.selectedRow.uuid)
      } else {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
    },
    eqQuantityChangeHandler() {
      ChargeUtils.eqQuantityChangeHandler(this.job, this.context)
    },
    // 自定义岗位字段1
    async userDefinedRoleId1Handler(data) {
      const job = this.job
      job.userDefinedRoleId1 = data.value || 0
      job.userDefinedRoleDept1 = 0
      job.userDefinedRoleOffice1 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole1', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              this.job.userDefinedRoleDept1 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice1 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole1')
          job.userDefinedRoleDept1 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice1 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段2
    async userDefinedRoleId2Handler(data) {
      const job = this.job
      job.userDefinedRoleId2 = data.value || 0
      job.userDefinedRoleDept2 = 0
      job.userDefinedRoleOffice2 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole2', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              this.job.userDefinedRoleDept2 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice2 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole2')
          job.userDefinedRoleDept2 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice2 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段3
    async userDefinedRoleId3Handler(fieldData) {
      const value = fieldData.value
      // if (!$store.getters.enableFrontEndPlugin) {
      //   value = fieldData.value
      // }
      const job = this.job
      job.userDefinedRoleId3 = value || 0
      job.userDefinedRoleDept3 = 0
      job.userDefinedRoleOffice3 = 0
      if (value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole3', value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              job.userDefinedRoleDept3 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice3 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(fieldData) // !$store.getters.enableFrontEndPlugin ? new User(fieldData) : new User({ value })
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole3')
          job.userDefinedRoleDept3 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice3 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段4
    async userDefinedRoleId4Handler(fieldData) {
      const value = fieldData.value
      // if (!$store.getters.enableFrontEndPlugin) {
      //   value = fieldData.value
      // }
      const job = this.job
      job.userDefinedRoleId4 = value || 0
      job.userDefinedRoleDept4 = 0
      job.userDefinedRoleOffice4 = 0
      if (value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole4', value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              job.userDefinedRoleDept4 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice4 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(fieldData) // !$store.getters.enableFrontEndPlugin ? new User(fieldData) : new User({ value })
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole4')
          job.userDefinedRoleDept4 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice4 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段5
    async userDefinedRoleId5Handler(data) {
      const job = this.job
      job.userDefinedRoleId5 = data.value || 0
      job.userDefinedRoleDept5 = 0
      job.userDefinedRoleOffice5 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole5', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              this.job.userDefinedRoleDept5 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice5 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole5')
          job.userDefinedRoleDept5 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice5 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段6
    async userDefinedRoleId6Handler(data) {
      const job = this.job
      job.userDefinedRoleId6 = data.value || 0
      job.userDefinedRoleDept6 = 0
      job.userDefinedRoleOffice6 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole6', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              this.job.userDefinedRoleDept6 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice6 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole6')
          job.userDefinedRoleDept6 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice6 = office ? office.officeId : 0
        }
      }
    },
    // 自定义岗位字段7
    async userDefinedRoleId7Handler(data) {
      const job = this.job
      job.userDefinedRoleId7 = data.value || 0
      job.userDefinedRoleDept7 = 0
      job.userDefinedRoleOffice7 = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole7', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              this.job.userDefinedRoleDept7 = item.departmentId
              const office = await Office.getOfficeById(item.officeId)
              job.userDefinedRoleOffice7 = office ? office.officeId : 0
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'userDefinedRole7')
          job.userDefinedRoleDept7 = dep ? dep.departmentId : 0
          const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
          job.userDefinedRoleOffice7 = office ? office.officeId : 0
        }
      }
    },
    warehouseNameChangeHandler(warehouseName) {
      if (this.job.warehouseInfo.length === 0) {
        return
      }
      const warehouseInfo = this.job.warehouseInfo[0]
      warehouseInfo.warehouseName = warehouseName
      const w = this.warehouseNameList.find(item => item.warehouseName === warehouseName)
      if (w) {
        warehouseInfo.warehouseContactTel = w.warehouseContactTel
        warehouseInfo.warehouseContact = w.warehouseContact
        warehouseInfo.warehouseAddress = w.warehouseAddress
        warehouseInfo.mapFile = w.mapFile
        if (w.remarks) {
          warehouseInfo.remarks = w.remarks
        }
      } else {
        warehouseInfo.warehouseContactTel = ''
        warehouseInfo.warehouseContact = ''
        warehouseInfo.warehouseAddress = ''
        warehouseInfo.mapFile = ''
        warehouseInfo.remarks = ''
      }
      this.pm.addWarehouseToModifiedSet(warehouseInfo)
    },
    async onMarkChange() {
      if (!this.view.isEdit) return
      await SeaImCargoDoc.changeSynData(new SeaImportJob(this.job), true)
    },
    dragging(e) {
      document.getElementById('app').classList.add('disabled-select')
      const division = this.$refs.division
      const divisionRect = division.getBoundingClientRect()
      const slaveDiv = this.$refs.slaveDiv
      const slaveDivRect = slaveDiv.getBoundingClientRect()
      // 拖拽偏移量（向上增加高度，向下缩减高度） = 拖拽图标位置 - 鼠标位置
      const dragOffset = divisionRect.top + this.divisionHalfHeight - e.clientY
      // 新的小票区域高度
      let newHeight = slaveDivRect.height + dragOffset
      // 表格最小高度为200
      if (newHeight < 200) {
        newHeight = 200
      }
      slaveDiv.style.height = newHeight + 'px'
      // 触发竖向的滚动条滚动
      this.$emit('verticalScroll', dragOffset)
    },
    async onCarrierIdChange(scacList, carrierScacEdit) {
      JobUtils.matchUserPortConfig(this, this.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.job)
      // 根据船公司带出对应的scac
      this.job.carrierScac = await JobUtils.getCarrierScac(this.job.carrierId, scacList, carrierScacEdit)
    },
    onCustomJobTypeChange(obj) {
      this.setJobSelectValue(obj)
      JobUtils.matchUserPortConfig(this, this.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.job)
      this.job.secondaryCustomJobType = ''
      this.setSecondaryCustomJobTypeFunc()
    },
    setSecondaryCustomJobTypeFunc() {
      if (this.job.customJobType) {
        this.secondaryCustomJobTypeList = JobUtils.setSecondaryCustomJobTypeList(this.job.customJobType, this.job.lob)
      } else {
        this.secondaryCustomJobTypeList = []
      }
    },
    setCustomJobTypeFunc() {
      this.customJobTypeList = JobUtils.setCustomJobTypeList(this.job.lob, this.job.containerLoadType, this.job.fba)
    },
    // 设置操作分公司
    setOpOffice(val) {
      this.job.opOffice = val
    }
  }
}
</script>

<style lang="scss">

  .jobNo-color.el-input {
    &.is-disabled {
      .el-input__inner{
        background: #99FF66;
      }
    }
  }
</style>

<!-- 中文样式 -->
<style scoped lang="scss">
#app.zh {
  .section::v-deep {
    &.center-two {
      width: 400px;
    }
  }
}
</style>

<!-- 英文样式 -->
<style scoped lang="scss">
#app.en {
  .section::v-deep {
    &.center-first {
      min-width: 420px;
    }
    &.center-two {
      width: 442px;
    }
    &.center-three {
      min-width: 364px;
    }
    &.center-four {
      width: 310px;
    }
  }
}
</style>

<style scoped>
.division {
  display: inline-block;
  width: 18px;
  margin-left: calc(40%);
  padding: 1px 0;
  cursor: ns-resize;
}
.division .line {
  width: 100%;
  height: 0px;
  margin-bottom: 1px;
  border-bottom: 2px solid #bdbdbd;
}
</style>
